import React, { FC } from 'react';
import Head from 'next/head';
import { getConf } from '@tyc-pc/core';

interface TYCHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
}

const TYCHead: FC<TYCHeadProps> = (props) => {
  const { title, description, keywords } = props;
  // for preconnect & dns-prefetch
  const conf = getConf();
  const { originCapi, originNapi } = conf?.fetchConfig || {};
  const originCdn = 'https://cdn.tianyancha.com';
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" itemProp="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="preconnect" href={originCdn} crossOrigin="anonymous" />
      <link rel="dns-prefetch" href={originCdn} />
      {originCapi && (
        <>
          <link rel="preconnect" href={originCapi} />
          <link rel="dns-prefetch" href={originCapi} />
        </>
      )}
      {originNapi && (
        <>
          <link rel="preconnect" href={originNapi} />
          <link rel="dns-prefetch" href={originNapi} />
        </>
      )}
      <link
        rel="shortcut icon"
        href="https://cdn.tianyancha.com/wap/images/18blue/weixinlogo.png"
        type="image/x-icon"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="https://cdn.tianyancha.com/wap/images/apple-touch-icon-180x180.png"
      />
      <link
        rel="icon"
        sizes="192x192"
        href="https://cdn.tianyancha.com/wap/images/icon-hires-192x192.png"
      />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="renderer" content="webkit" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    </Head>
  );
};

export default TYCHead;
